import React from "react";
import { useNavigate } from "react-router-dom";

const WhatWeDo = () => {
  const navigate = useNavigate();
  const outcomeCards = [
    {
      title:
        "Increase revenue through personalization, CVM, and dynamic pricing",
      buttonText: "Explore Revenue Growth",
      link: "/revenue-growth",
    },
    {
      title: "Enhance customer experience with voice, chat, and omnichannel AI",
      buttonText: "Explore Customer Engagement",
      link: "/customer-experience",
    },
    {
      title:
        "Improve efficiency by automating ETL, campaign cycles, and document workflows",
      buttonText: "Explore Operational Efficiency",
      link: "/operational-cost",
    },
  ];

  return (
    <div className="w-full bg-white py-12 lg:py-18">
      <div className="w-[88%] lg:w-[80%] mx-auto">
        {/* Header Section */}
        <div className="mb-8 lg:mb-12">
          <h2 className="text-[32px] lg:text-[48px] xl:text-[56px] text-dark-blue RoobertLight leading-[120%] mb-2">
            What we do
          </h2>
          <h3 className="text-[20px] lg:text-[24px] xl:text-[28px] text-dark-blue RoobertMedium leading-[120%] mb-6">
            Business outcomes. Delivered by teams of humans and AI coworkers.
          </h3>
          <p className="text-[16px] lg:text-[18px] text-[#1E1E1E] RoobertRegular leading-[140%] mb-8 max-w-[800px]">
            OBZ works with enterprises to solve real problems - across growth,
            experience, and efficiency - by embedding lean expert teams
            augmented with purpose-built AI agents.
          </p>
          <p className="text-[16px] lg:text-[18px] text-[#1E1E1E] RoobertRegular leading-[140%] mb-12">
            We work with enterprise teams to:
          </p>
        </div>

        {/* Outcome Cards Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-12 mb-8 lg:mb-12">
          {outcomeCards.map((card, index) => (
            <div
              key={index}
              className="bg-dark-blue p-6 lg:p-8 flex flex-col justify-between min-h-[250px] lg:min-h-[280px] relative items-center"
            >
              <div className="flex-1">
                <p className="text-white RoobertMedium text-[16px] lg:text-[18px] leading-[140%]">
                  {card.title}
                </p>
              </div>
              <div className="mt-6">
                <button
                  className="bg-[#66FF00] text-black px-2 py-3 RoobertSemiBold text-[14px] lg:text-[16px] hover:bg-[#5AE600] transition-colors duration-200"
                  onClick={() => navigate(card.link)}
                >
                  {card.buttonText}
                </button>
              </div>
              <div className="border-r-4 border-t-4 border-fluoro-green absolute top-0 right-0 w-1/3 h-1/3"></div>
            </div>
          ))}
        </div>

        {/* Concluding Section */}
        <div className="mb-8">
          <p className="text-[16px] lg:text-[20px] text-[#1E1E1E] RoobertRegular leading-[140%] mb-8 max-w-[900px]">
            Every engagement is shaped by clear KPIs, reusable assets, and
            production-ready components - built on AWS, aligned to your roadmap,
            and ready to scale.
          </p>

          {/* Logos Section */}
          {/* <div className="flex items-center gap-4 lg:gap-6">
            <img
              src="/images/home/aws_black.svg"
              alt="AWS"
              className="h-8 lg:h-10 w-auto"
            />
            <div className="text-[#66FF00] text-2xl lg:text-3xl font-bold">×</div>
            <img
              src="/logo.png"
              alt="logo"
              className="h-8 lg:h-10 w-auto"
            /> 
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default WhatWeDo;
